<mat-expansion-panel
  [expanded]="expanded"
  [hideToggle]="displayMode !== 'header'"
  class="collapsable-panel"
>

  <mat-expansion-panel-header
    *ngIf="displayMode === 'header'; else buttonContainer"
    class="collapsable-panel-header"
  >
    <mat-panel-title class="collapsable-panel-header-title">{{ title | translate }}</mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template #buttonContainer>
    <button
      mat-stroked-button
      (click)="handleToggle()"
      color="primary"
      class="collapsable-panel-button"
    >
      {{ title | translate }}
      <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </ng-template>

  <ng-content></ng-content>

</mat-expansion-panel>
